import { FC } from 'react';
import { Skeleton, SkeletonProps } from '@chakra-ui/react';

const PaymentCardLimitsSkeleton: FC<SkeletonProps> = ({
  children,
  isLoaded,
  ...props
}) => (
  <Skeleton
    borderRadius="radius-4"
    endColor="grey.4"
    height={!isLoaded ? '8px' : 'auto'}
    isLoaded={isLoaded}
    speed={0.6}
    startColor="grey.2"
    {...props}
  >
    {children}
  </Skeleton>
);

export default PaymentCardLimitsSkeleton;
